
import React, { Fragment, useState, useEffect } from 'react'
import { array, bool, func, string } from 'prop-types'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import { DESCRICAO_MODAL_ESCOLHER_DATA_COBRANCA, TITULO_MODAL_ESCOLHER_DATA_COBRANCA } from './constantsModalTrocaDataCobranca'

const WrapperModal = styled.div`
  width: 100%;

  p {
    margin: 0;
  }

  #datas-cobranca {
    flex-wrap: wrap;
    justify-content: center;

    & > div {
      width: 30%;

      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        width: 50%;
      }
    }
  }

  .conteudo__modal {
    margin: 0 auto;
    max-width: 375px;
    text-align: center;

    p {
      ${StyleGuide.tipografia.textoPequeno}
      margin: 5px 0 40px;
    }
  }

  .botao__modal {
    margin-top: 40px;
    text-align: center;

    & > button:last-of-type {
      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        margin-left: 10px;
      }
    }
  }

  .wrapper__radio__button {
    cursor: pointer;

    p {
      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        font-size: 14px
      }
    }
  }
`

const ModalTrocaDataCobranca = ( { diaCobrancaAtual, datasPossiveisCobranca, closeModal, showModal, onCancelar, onConfirmar } ) => {
  const [ selecaoDataCobranca, setSelecaoDataCobranca ] = useState()

  const pegarDadosDataCobranca = dataCobranca => {
    return datasPossiveisCobranca.find( data => data.dia === parseInt( dataCobranca, 10 ) )
  }

  useEffect( () => {
    if ( diaCobrancaAtual ) {
      const dataCobranca = pegarDadosDataCobranca( diaCobrancaAtual )
      setSelecaoDataCobranca( dataCobranca )
    }
  }, [ diaCobrancaAtual ] )

  return (
    <Modal
      altura="auto"
      largura="560px"
      onShowModal={ closeModal }
      show={ showModal }
    >
      <WrapperModal>
        { datasPossiveisCobranca.length ?
          <Fragment>
            <div className="conteudo__modal">
              <h3>{ TITULO_MODAL_ESCOLHER_DATA_COBRANCA }</h3>
              <p>{ DESCRICAO_MODAL_ESCOLHER_DATA_COBRANCA }</p>
            </div>
            <RadioGroup
              defaultOption={ selecaoDataCobranca ? selecaoDataCobranca.dia : null }
              group="datas-cobranca"
              itemsDirection="row"
              itemsPadding="0"
              listDirection="row"
              onChange={ codigo => setSelecaoDataCobranca( pegarDadosDataCobranca( codigo.optionChecked ) ) }
            >
              { datasPossiveisCobranca.map( data => (
                <RadioButton
                  group="datas-cobranca"
                  id={ data.dia }
                  key={ data.dia }
                  value={ data.dia }
                >
                  <div className="wrapper__radio__button">
                    <p>{ `Dia ${data.dia} do mês`}</p>
                  </div>
                </RadioButton>
              ) ) }
            </RadioGroup>
            <div className="botao__modal">
              <Button
                fullWidth={ StyleGuide.isMobile() }
                invertido
                onClick={ () => onCancelar() }
              >
                Cancelar
              </Button>
              <Button
                fullWidth={ StyleGuide.isMobile() }
                hasSpaceBottom={ !StyleGuide.isMobile() }
                onClick={ () => onConfirmar( selecaoDataCobranca && selecaoDataCobranca.id ) }
              >
                Confirmar
              </Button>
            </div>
          </Fragment> : null}
      </WrapperModal>
    </Modal>
  )
}

ModalTrocaDataCobranca.propTypes = {
  'closeModal': func.isRequired,
  'datasPossiveisCobranca': array.isRequired,
  'diaCobrancaAtual': string.isRequired,
  'onCancelar': func,
  'onConfirmar': func,
  'showModal': bool
}

ModalTrocaDataCobranca.defaultProps = {
  'onCancelar': () => null,
  'onConfirmar': () => null,
  'showModal': false
}

export default ModalTrocaDataCobranca
